module.exports = __webpack_public_path__ + "img/box19-icon.3823a474.png";